import { Eye, EyeSlash } from "iconsax-react";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "../../../utils/axios";

function ResetPass({ data }) {
	const [pass, setPass] = useState("");
	const [confirmPass, setConfirmPass] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPass, setConfirmShowPass] = useState(false);
	const [invalidPass, setInvalidPass] = useState(null);
	const navigate = useNavigate();

	function formOnSubmitHandler(e) {
		e.preventDefault();
		if (invalidPass) return;

		api
			.post("/reset_password", {
				...data,
				new_password: pass,
				confirm_password: confirmPass,
			})
			.then((res) => {
				toast.success("رمز عبور شما با موفقیت تغییر کرد");
				setTimeout(() => {
					navigate("/login");
				}, 800);
			})
			.catch((err) => {
				toast.error(err?.response?.data?.error);
			});
	}

	useEffect(() => {
		if (confirmPass !== pass) {
			setInvalidPass(true);
		} else setInvalidPass(false);
	}, [confirmPass]);

	return (
		<>
			<h2 className="login-title">فراموشی رمز عبور</h2>
			<form className="login-form" onSubmit={formOnSubmitHandler}>
				<div className="form-group">
					<input
						type={showPassword ? "text" : "password"}
						id="password"
						name="password"
						className="form-control has-icon"
						value={pass}
						onChange={(e) => setPass(e.target.value)}
						autoComplete="current-password"
						placeholder="رمز عبور"
					/>
					<button
						type="button"
						className="login-input-icon"
						tabIndex={-1}
						style={{
							background: "none",
							border: "none",
							padding: 0,
							cursor: "pointer",
						}}
						onClick={() => setShowPassword((v) => !v)}
						aria-label={showPassword ? "مخفی کردن رمز" : "نمایش رمز"}
					>
						{showPassword ? (
							<EyeSlash size={20} variant="Linear" />
						) : (
							<Eye size={20} variant="Linear" />
						)}
					</button>
				</div>
				{/*confirm pass*/}
				<div className="form-group">
					<input
						type={showConfirmPass ? "text" : "password"}
						id="confirm-password"
						name="confirm-password"
						className="form-control has-icon"
						value={confirmPass}
						onChange={(e) => setConfirmPass(e.target.value)}
						placeholder="تکرار رمز عبور"
					/>
					<button
						type="button"
						className="login-input-icon"
						tabIndex={-1}
						style={{
							background: "none",
							border: "none",
							padding: 0,
							cursor: "pointer",
						}}
						onClick={() => setConfirmShowPass((v) => !v)}
						aria-label={showConfirmPass ? "مخفی کردن رمز" : "نمایش رمز"}
					>
						{showConfirmPass ? (
							<EyeSlash size={20} variant="Linear" />
						) : (
							<Eye size={20} variant="Linear" />
						)}
					</button>
					{invalidPass && (
						<div className={"form-helper text-danger mb-3"}>
							رمز عبور با تکرار آن یکسان نیست
						</div>
					)}
				</div>
				<div className="form-btn-group">
					<button type="submit" className="btn btn-primary">
						تغییر رمز عبور
					</button>
				</div>
			</form>
		</>
	);
}
export default ResetPass;
